import { FormInstance } from 'antd';

export const toLowerCase = (form: FormInstance, field: string): void => {
  const email = form.getFieldValue(field).toLowerCase();
  form.setFieldsValue({
    ...form.getFieldsValue(),
    email,
  });
};
